import React, { useState, useEffect } from "react";
import "./SizeChart.scss";
// import "../../styles/common.scss";
import MicroModal from "micromodal";
import { Portal } from "react-portal";

const SizeChart = ({ page, visible, onClose }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isMetric, setMetric] = useState(true);

  useEffect(() => {
    MicroModal.init();
  }, []);

  return (
    <div className="size-chart-wrapper">
      <button
        type="button"
        data-micromodal-trigger="size-chart-modal"
        className="size-chart-open-button"
      >
        Size Chart
      </button>

      <Portal>
        <div className="size-chart-modal-wrapper">
          <div className="product-details-size-chart">
            <div
              className="modal micromodal-slide size-chart-modal"
              id="size-chart-modal"
              aria-hidden="true"
            >
              <div className="modal__overlay" tabIndex="-1" data-micromodal-close>
                <div
                  className="modal__container"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="size-chart-modal-title"
                >
                  <header className="modal__header">
                    <h2 className="modal__title" id="size-chart-modal-title">
                      Size Chart
                    </h2>

                    <button
                      type="button"
                      className="modal__close"
                      aria-label="Close modal"
                      data-micromodal-close
                    >X</button>
                  </header>

                  <main className="modal__content" id="size-chart-modal-content">
                    <div className="pw-tabs" data-selected-index="0">
                      <div className="pw-tabs__strip-container">
                        <ol role="tablist" className="pw-tabs__strip">
                          <li
                            className={`pw-tabs__tab ${selectedIndex === 0 ? "pw--is-active" : ""
                              }`}
                            role="presentation"
                          >
                            <a
                              className="pw-tabs__link"
                              role="tab"
                              tabIndex="0"
                              aria-selected={selectedIndex === 0}
                              onClick={() => setSelectedIndex(0)}
                            >
                              Men's Charts
                            </a>
                          </li>
                          <li
                            className={`pw-tabs__tab ${selectedIndex === 1 ? "pw--is-active" : ""
                              }`}
                            role="presentation"
                          >
                            <a
                              className="pw-tabs__link"
                              role="tab"
                              tabIndex="0"
                              aria-selected={selectedIndex === 1}
                              onClick={() => setSelectedIndex(1)}
                            >
                              Women's Charts
                            </a>
                          </li>
                        </ol>
                      </div>

                      {isMetric ? (
                        <div className="pw-tabs__panels">
                          <div
                            className={`pw-tabs__panel ${selectedIndex === 0 ? "pw--is-active" : ""
                              }`}
                            role="tabpanel"
                            aria-hidden={selectedIndex === 0}
                            tabIndex="-1"
                          >
                            <div className="u-padding-md">
                              <div
                                className="size-chart-modal-units"
                                onClick={() => setMetric(false)}
                                tabIndex="0"
                              >
                                <p className="u-text-align-center">
                                  Shown in centimeters.{" "}
                                  <span>Convert to inches.</span>
                                </p>
                              </div>

                              <div>
                                <h4>Big Sizes: 1X x BG - 5X x BGL</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Chest</th>
                                      <th>Neck</th>
                                      <th>Sleeve</th>
                                      <th>Waist</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>1X x BG</td>
                                      <td>122 - 127</td>
                                      <td>47 - 48</td>
                                      <td>89 - 90</td>
                                      <td>104 - 109</td>
                                    </tr>
                                    <tr>
                                      <td>2X x BG</td>
                                      <td>130 - 137</td>
                                      <td>50 - 51</td>
                                      <td>90 - 91</td>
                                      <td>112 - 117</td>
                                    </tr>
                                    <tr>
                                      <td>3X x BG</td>
                                      <td>140 - 147</td>
                                      <td>52 - 53</td>
                                      <td>91 - 93</td>
                                      <td>119 - 124</td>
                                    </tr>
                                    <tr>
                                      <td>4X x BG</td>
                                      <td>150 - 157</td>
                                      <td>55 - 56</td>
                                      <td>93 - 94</td>
                                      <td>127 - 132</td>
                                    </tr>
                                    <tr>
                                      <td>5X x BG</td>
                                      <td>160 - 168</td>
                                      <td>57 - 58</td>
                                      <td>94 - 95</td>
                                      <td>135 - 140</td>
                                    </tr>
                                  </tbody>
                                </table>

                                <h4>Tall Sizes: L x TL - 4X x TL</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Chest</th>
                                      <th>Neck</th>
                                      <th>Sleeve</th>
                                      <th>Waist</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>L x TL</td>
                                      <td>107 - 114</td>
                                      <td>42 - 43</td>
                                      <td>91 - 93</td>
                                      <td>94 - 99</td>
                                    </tr>
                                    <tr>
                                      <td>XL x TL</td>
                                      <td>117 - 124</td>
                                      <td>45 - 46</td>
                                      <td>94 - 95</td>
                                      <td>104 - 109</td>
                                    </tr>
                                    <tr>
                                      <td>2XL x TL</td>
                                      <td>127 - 135</td>
                                      <td>47 - 48</td>
                                      <td>97 - 98</td>
                                      <td>112 - 117</td>
                                    </tr>
                                    <tr>
                                      <td>3XL x TL</td>
                                      <td>137 - 145</td>
                                      <td>50 - 51</td>
                                      <td>99 - 100</td>
                                      <td>119 - 124</td>
                                    </tr>
                                    <tr>
                                      <td>4XL x TL</td>
                                      <td>147 - 155</td>
                                      <td>51 - 52</td>
                                      <td>102 - 103</td>
                                      <td>127 - 132</td>
                                    </tr>
                                  </tbody>
                                </table>

                                <h4>Tops: XS - 3XL</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Chest</th>
                                      <th>Neck</th>
                                      <th>Sleeve</th>
                                      <th>Waist</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XS</td>
                                      <td>84 - 89</td>
                                      <td>36 - 37</td>
                                      <td>83</td>
                                      <td>69 - 71</td>
                                    </tr>
                                    <tr>
                                      <td>S</td>
                                      <td>91 - 97</td>
                                      <td>37 - 38</td>
                                      <td>81 - 84</td>
                                      <td>74 - 79</td>
                                    </tr>
                                    <tr>
                                      <td>M</td>
                                      <td>99 - 104</td>
                                      <td>39 - 41</td>
                                      <td>84 - 86</td>
                                      <td>81 - 86</td>
                                    </tr>
                                    <tr>
                                      <td>L</td>
                                      <td>107 - 112</td>
                                      <td>42 - 43</td>
                                      <td>86 - 89</td>
                                      <td>89 - 94</td>
                                    </tr>
                                    <tr>
                                      <td>XL</td>
                                      <td>114 - 119</td>
                                      <td>45 - 46</td>
                                      <td>89</td>
                                      <td>96 - 102</td>
                                    </tr>
                                    <tr>
                                      <td>XXL/2XL</td>
                                      <td>123 - 127</td>
                                      <td>47 - 48</td>
                                      <td>91 - 94</td>
                                      <td>104 - 109</td>
                                    </tr>
                                    <tr>
                                      <td>3XL</td>
                                      <td>130 - 135</td>
                                      <td>50 - 51</td>
                                      <td>94 - 97</td>
                                      <td>112 - 117</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Pants: XS - XXL</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Waist</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XS</td>
                                      <td>69 - 71</td>
                                    </tr>
                                    <tr>
                                      <td>S</td>
                                      <td>74 - 79</td>
                                    </tr>
                                    <tr>
                                      <td>M</td>
                                      <td>81 - 86</td>
                                    </tr>
                                    <tr>
                                      <td>L</td>
                                      <td>89 - 94</td>
                                    </tr>
                                    <tr>
                                      <td>XL</td>
                                      <td>97 - 102</td>
                                    </tr>
                                    <tr>
                                      <td>XLX</td>
                                      <td>n/a</td>
                                    </tr>
                                    <tr>
                                      <td>XXL</td>
                                      <td>104 - 109</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Footwear</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>U.S. Size</th>
                                      <th>Euro Size</th>
                                      <th>Centemeters</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>6</td>
                                      <td>38</td>
                                      <td>24</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>39</td>
                                      <td>24</td>
                                    </tr>
                                    <tr>
                                      <td>7.5</td>
                                      <td>40 - 41</td>
                                      <td>25</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>41</td>
                                      <td>25</td>
                                    </tr>
                                    <tr>
                                      <td>8.5</td>
                                      <td>41 - 42</td>
                                      <td>26</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>42</td>
                                      <td>26</td>
                                    </tr>
                                    <tr>
                                      <td>9.5</td>
                                      <td>42 - 43</td>
                                      <td>27</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td>43</td>
                                      <td>27</td>
                                    </tr>
                                    <tr>
                                      <td>10.5</td>
                                      <td>43 - 44</td>
                                      <td>27</td>
                                    </tr>
                                    <tr>
                                      <td>11</td>
                                      <td>44</td>
                                      <td>28</td>
                                    </tr>
                                    <tr>
                                      <td>11.5</td>
                                      <td>44 - 45</td>
                                      <td>28</td>
                                    </tr>
                                    <tr>
                                      <td>12</td>
                                      <td>45</td>
                                      <td>29</td>
                                    </tr>
                                    <tr>
                                      <td>13</td>
                                      <td>46</td>
                                      <td>29</td>
                                    </tr>
                                    <tr>
                                      <td>14</td>
                                      <td>47</td>
                                      <td>30</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Men's Hats</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Alpha</th>
                                      <th>Fitted</th>
                                      <th>Centimeters</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>S/M</td>
                                      <td>6 7/8 - 7 1/8</td>
                                      <td>55 - 57</td>
                                    </tr>
                                    <tr>
                                      <td>OSFM*</td>
                                      <td>7 1/8 - 7 3/8</td>
                                      <td>57 - 59</td>
                                    </tr>
                                    <tr>
                                      <td>L/XL</td>
                                      <td>7 3/8 - 7 5/8</td>
                                      <td>59 - 61</td>
                                    </tr>
                                    <tr>
                                      <td>XXL</td>
                                      <td>7 3/4 - 7 7/8</td>
                                      <td>62 - 63</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <p className="chart-note">
                                          * One Size Fits Most
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Men's Belts</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Centimeters</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>S</td>
                                      <td>76 - 81</td>
                                    </tr>
                                    <tr>
                                      <td>M</td>
                                      <td>86 - 91</td>
                                    </tr>
                                    <tr>
                                      <td>L</td>
                                      <td>97 - 102</td>
                                    </tr>
                                    <tr>
                                      <td>XL</td>
                                      <td>107 - 112</td>
                                    </tr>
                                    <tr>
                                      <td>1X</td>
                                      <td>117 - 122</td>
                                    </tr>
                                    <tr>
                                      <td>2X</td>
                                      <td>127 - 132</td>
                                    </tr>
                                    <tr>
                                      <td>3X</td>
                                      <td>137 - 142</td>
                                    </tr>
                                    <tr>
                                      <td>4X</td>
                                      <td>142 - 147</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`pw-tabs__panel ${selectedIndex === 1 ? "pw--is-active" : ""
                              }`}
                            role="tabpanel"
                            aria-hidden={selectedIndex === 1}
                          >
                            <div className="u-padding-md">
                              <div
                                className="size-chart-modal-units"
                                onClick={() => setMetric(false)}
                                tabIndex="0"
                              >
                                <p className="u-text-align-center">
                                  Shown in centimeters.{" "}
                                  <span>Convert to inches.</span>
                                </p>
                              </div>

                              <div>
                                <h4>Apparel | XXS - XL, 0-16</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Bust</th>
                                      <th>Waist</th>
                                      <th>Hips</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XXS / 0</td>
                                      <td>82.6</td>
                                      <td>63.5</td>
                                      <td>90.2</td>
                                    </tr>
                                    <tr>
                                      <td>XS / 2</td>
                                      <td>85.1</td>
                                      <td>67.3</td>
                                      <td>94</td>
                                    </tr>
                                    <tr>
                                      <td>S / 4-6</td>
                                      <td>87.6 - 90.2</td>
                                      <td>69.9 - 72.4</td>
                                      <td>96.5 - 99.1</td>
                                    </tr>
                                    <tr>
                                      <td>M / 8-10</td>
                                      <td>92.7 - 95.3</td>
                                      <td>74.9 - 77.5</td>
                                      <td>101.6 - 104.1</td>
                                    </tr>
                                    <tr>
                                      <td>L / 12-14</td>
                                      <td>99.1 - 102.9</td>
                                      <td>81.3 - 85.1</td>
                                      <td>108 - 111.8</td>
                                    </tr>
                                    <tr>
                                      <td>XL / 16</td>
                                      <td>106.7</td>
                                      <td>88.9</td>
                                      <td>115.6</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Denim | 24-33</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Natural Waist</th>
                                      <th>Low Hip</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>24</td>
                                      <td>61</td>
                                      <td>85</td>
                                    </tr>
                                    <tr>
                                      <td>25</td>
                                      <td>64</td>
                                      <td>89</td>
                                    </tr>
                                    <tr>
                                      <td>26</td>
                                      <td>66</td>
                                      <td>93</td>
                                    </tr>
                                    <tr>
                                      <td>27</td>
                                      <td>69</td>
                                      <td>95</td>
                                    </tr>
                                    <tr>
                                      <td>28</td>
                                      <td>71</td>
                                      <td>98</td>
                                    </tr>
                                    <tr>
                                      <td>29</td>
                                      <td>74</td>
                                      <td>100</td>
                                    </tr>
                                    <tr>
                                      <td>30</td>
                                      <td>76</td>
                                      <td>103</td>
                                    </tr>
                                    <tr>
                                      <td>31</td>
                                      <td>80</td>
                                      <td>107</td>
                                    </tr>
                                    <tr>
                                      <td>32</td>
                                      <td>84</td>
                                      <td>110</td>
                                    </tr>
                                    <tr>
                                      <td>33</td>
                                      <td>88</td>
                                      <td>114</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Swim Separates</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Bust</th>
                                      <th>Waist</th>
                                      <th>Hips</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XS / 4</td>
                                      <td>85</td>
                                      <td>69</td>
                                      <td>94</td>
                                    </tr>
                                    <tr>
                                      <td>S / 6-8</td>
                                      <td>88</td>
                                      <td>71</td>
                                      <td>97</td>
                                    </tr>
                                    <tr>
                                      <td>M / 10-12</td>
                                      <td>91</td>
                                      <td>75</td>
                                      <td>100</td>
                                    </tr>
                                    <tr>
                                      <td>L / 14</td>
                                      <td>95</td>
                                      <td>79</td>
                                      <td>104</td>
                                    </tr>
                                    <tr>
                                      <td>XL / 16</td>
                                      <td>95</td>
                                      <td>79</td>
                                      <td>104</td>
                                    </tr>
                                    <tr>
                                      <td>1X / 16W</td>
                                      <td>109</td>
                                      <td>91</td>
                                      <td>117</td>
                                    </tr>
                                    <tr>
                                      <td>2X / 18W-20W</td>
                                      <td>113</td>
                                      <td>95</td>
                                      <td>121</td>
                                    </tr>
                                    <tr>
                                      <td>3X / 22W</td>
                                      <td>117</td>
                                      <td>99</td>
                                      <td>124</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>One-Piece Suits</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Bust</th>
                                      <th>Waist</th>
                                      <th>Hips</th>
                                      <th>Torso Length</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>4</td>
                                      <td>83</td>
                                      <td>66</td>
                                      <td>91</td>
                                      <td>151</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>85</td>
                                      <td>69</td>
                                      <td>94</td>
                                      <td>154</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>88</td>
                                      <td>71</td>
                                      <td>97</td>
                                      <td>158</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td>91</td>
                                      <td>74</td>
                                      <td>99</td>
                                      <td>161</td>
                                    </tr>
                                    <tr>
                                      <td>12</td>
                                      <td>93</td>
                                      <td>76</td>
                                      <td>102</td>
                                      <td>164</td>
                                    </tr>
                                    <tr>
                                      <td>14</td>
                                      <td>95</td>
                                      <td>79</td>
                                      <td>104</td>
                                      <td>167</td>
                                    </tr>
                                    <tr>
                                      <td>16</td>
                                      <td>98</td>
                                      <td>81</td>
                                      <td>107</td>
                                      <td>170</td>
                                    </tr>
                                    <tr>
                                      <td>16W</td>
                                      <td>109</td>
                                      <td>91</td>
                                      <td>117</td>
                                      <td>175</td>
                                    </tr>
                                    <tr>
                                      <td>18W</td>
                                      <td>112</td>
                                      <td>94</td>
                                      <td>119</td>
                                      <td>178</td>
                                    </tr>
                                    <tr>
                                      <td>20W</td>
                                      <td>114</td>
                                      <td>97</td>
                                      <td>122</td>
                                      <td>182</td>
                                    </tr>
                                    <tr>
                                      <td>22W</td>
                                      <td>117</td>
                                      <td>99</td>
                                      <td>124</td>
                                      <td>185</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Swim Coverups</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Bust</th>
                                      <th>Waist</th>
                                      <th>Hips</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XS / 4</td>
                                      <td>85</td>
                                      <td>69</td>
                                      <td>94</td>
                                    </tr>
                                    <tr>
                                      <td>S / 6-8</td>
                                      <td>88</td>
                                      <td>71</td>
                                      <td>97</td>
                                    </tr>
                                    <tr>
                                      <td>M / 10-12</td>
                                      <td>93</td>
                                      <td>76</td>
                                      <td>102</td>
                                    </tr>
                                    <tr>
                                      <td>L / 14</td>
                                      <td>98</td>
                                      <td>81</td>
                                      <td>107</td>
                                    </tr>
                                    <tr>
                                      <td>XL / 16</td>
                                      <td>103</td>
                                      <td>86</td>
                                      <td>112</td>
                                    </tr>
                                    <tr>
                                      <td>1X / 16W</td>
                                      <td>109</td>
                                      <td>91</td>
                                      <td>117</td>
                                    </tr>
                                    <tr>
                                      <td>2X / 18W-20W</td>
                                      <td>114</td>
                                      <td>97</td>
                                      <td>122</td>
                                    </tr>
                                    <tr>
                                      <td>3X / 22W</td>
                                      <td>119</td>
                                      <td>102</td>
                                      <td>127</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Footwear</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>U.S. Size</th>
                                      <th>Euro Size</th>
                                      <th>Centimeters</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>6</td>
                                      <td>36 - 37</td>
                                      <td>23</td>
                                    </tr>
                                    <tr>
                                      <td>6.5</td>
                                      <td>37</td>
                                      <td>23</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>37 - 38</td>
                                      <td>24</td>
                                    </tr>
                                    <tr>
                                      <td>7.5</td>
                                      <td>38</td>
                                      <td>24</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>38 - 39</td>
                                      <td>24</td>
                                    </tr>
                                    <tr>
                                      <td>8.5</td>
                                      <td>39</td>
                                      <td>24</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>39 - 40</td>
                                      <td>25</td>
                                    </tr>
                                    <tr>
                                      <td>9.5</td>
                                      <td>40</td>
                                      <td>25</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td>40 - 41</td>
                                      <td>26</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Women's Hats</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Alpha</th>
                                      <th>Hat Size</th>
                                      <th>Centimeters</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>OSFM*</td>
                                      <td>6 7/8 - 7 1/8</td>
                                      <td>55 - 58</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <p className="chart-note">
                                          * One Size Fits Most
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Women's Belts</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Pant Size</th>
                                      <th>Belt Size (Buckle)</th>
                                      <th>Belt Size (Braid)</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>2</td>
                                      <td>76 - 81</td>
                                      <td>79 - 84</td>
                                    </tr>
                                    <tr>
                                      <td>4/6</td>
                                      <td>81 - 86</td>
                                      <td>84 - 89</td>
                                    </tr>
                                    <tr>
                                      <td>8/10</td>
                                      <td>86 - 91</td>
                                      <td>89 - 94</td>
                                    </tr>
                                    <tr>
                                      <td>12/14</td>
                                      <td>94 - 99</td>
                                      <td>96 - 102</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Women's Belts: Alpha Sizing</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Alpha</th>
                                      <th>Pant Size</th>
                                      <th>Centimeters</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XS/S</td>
                                      <td>2 - 6</td>
                                      <td>76.2 - 86.4</td>
                                    </tr>
                                    <tr>
                                      <td>M/L</td>
                                      <td>8 - 14</td>
                                      <td>88.9 - 99.1</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="pw-tabs__panels">
                          <div
                            className={`pw-tabs__panel ${selectedIndex === 0 ? "pw--is-active" : ""
                              }`}
                            role="tabpanel"
                            aria-hidden={selectedIndex === 0}
                          >
                            <div className="u-padding-md">
                              <div
                                className="size-chart-modal-units"
                                onClick={() => setMetric(true)}
                                tabIndex="0"
                              >
                                <p className="u-text-align-center">
                                  Shown in inches.{" "}
                                  <span>Convert to centimeters.</span>
                                </p>
                              </div>

                              <div>
                                <h4>Big Sizes: 1X x BG - 5X x BGL</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Chest</th>
                                      <th>Neck</th>
                                      <th>Sleeve</th>
                                      <th>Waist</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>1XLB</td>
                                      <td>48 - 50</td>
                                      <td>18.5 - 19</td>
                                      <td>35 - 35.5</td>
                                      <td>41 - 43</td>
                                    </tr>
                                    <tr>
                                      <td>2XLB</td>
                                      <td>51 - 54</td>
                                      <td>19.5 - 20</td>
                                      <td>35.5 - 36</td>
                                      <td>44 - 46</td>
                                    </tr>
                                    <tr>
                                      <td>3XLB</td>
                                      <td>55 - 58</td>
                                      <td>20.5 - 21</td>
                                      <td>36 - 36.5</td>
                                      <td>47 - 49</td>
                                    </tr>
                                    <tr>
                                      <td>4XLB</td>
                                      <td>59 - 62</td>
                                      <td>21.5 - 22</td>
                                      <td>36.5 - 37</td>
                                      <td>50 - 52</td>
                                    </tr>
                                    <tr>
                                      <td>5XLB</td>
                                      <td>63 - 66</td>
                                      <td>22.5 - 23</td>
                                      <td>37 - 37.5</td>
                                      <td>53 - 55</td>
                                    </tr>
                                  </tbody>
                                </table>

                                <h4>Tall Sizes: L x TL - 4X x TL</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Chest</th>
                                      <th>Neck</th>
                                      <th>Sleeve</th>
                                      <th>Waist</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>L x TL</td>
                                      <td>42 - 45</td>
                                      <td>16.5 - 17</td>
                                      <td>36 - 36.5</td>
                                      <td>37 - 39</td>
                                    </tr>
                                    <tr>
                                      <td>XL x TL</td>
                                      <td>46 - 49</td>
                                      <td>17.5 - 18</td>
                                      <td>37 - 37.5</td>
                                      <td>41 - 43</td>
                                    </tr>
                                    <tr>
                                      <td>2XL x TL</td>
                                      <td>50 - 53</td>
                                      <td>18.5 - 19</td>
                                      <td>38 - 38.5</td>
                                      <td>44 - 46</td>
                                    </tr>
                                    <tr>
                                      <td>3XL x TL</td>
                                      <td>54 - 57</td>
                                      <td>19.5 - 20</td>
                                      <td>39 - 39.5</td>
                                      <td>47 - 49</td>
                                    </tr>
                                    <tr>
                                      <td>4XL x TL</td>
                                      <td>58 - 61</td>
                                      <td>20 - 20.5</td>
                                      <td>40 - 40.5</td>
                                      <td>50 - 52</td>
                                    </tr>
                                  </tbody>
                                </table>

                                <h4>Tops: XS - 3XL</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Chest</th>
                                      <th>Neck</th>
                                      <th>Sleeve</th>
                                      <th>Waist</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XS</td>
                                      <td>33 - 35</td>
                                      <td>14 - 14.5</td>
                                      <td>32.5</td>
                                      <td>27 - 28</td>
                                    </tr>
                                    <tr>
                                      <td>S</td>
                                      <td>36 - 38</td>
                                      <td>14.5 - 15</td>
                                      <td>32 - 33</td>
                                      <td>29 - 31</td>
                                    </tr>
                                    <tr>
                                      <td>M</td>
                                      <td>39 - 41</td>
                                      <td>15.5 - 16</td>
                                      <td>33 - 34</td>
                                      <td>32 - 34</td>
                                    </tr>
                                    <tr>
                                      <td>L</td>
                                      <td>42 - 44</td>
                                      <td>16.5 - 17</td>
                                      <td>34 - 35</td>
                                      <td>35 - 37</td>
                                    </tr>
                                    <tr>
                                      <td>XL</td>
                                      <td>45 - 47</td>
                                      <td>17.5 - 18</td>
                                      <td>35 - 36</td>
                                      <td>38 - 40</td>
                                    </tr>
                                    <tr>
                                      <td>XXL/2XL</td>
                                      <td>48 - 50</td>
                                      <td>18.5 - 19</td>
                                      <td>36 - 37</td>
                                      <td>41 - 43</td>
                                    </tr>
                                    <tr>
                                      <td>3XL</td>
                                      <td>51 - 53</td>
                                      <td>19.5 - 20</td>
                                      <td>37 - 38</td>
                                      <td>44 - 46</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Pants: XS - XXL</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Waist</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XS</td>
                                      <td>27 - 28</td>
                                    </tr>
                                    <tr>
                                      <td>S</td>
                                      <td>29 - 31</td>
                                    </tr>
                                    <tr>
                                      <td>M</td>
                                      <td>32 - 34</td>
                                    </tr>
                                    <tr>
                                      <td>L</td>
                                      <td>35 - 37</td>
                                    </tr>
                                    <tr>
                                      <td>XL</td>
                                      <td>38 - 40</td>
                                    </tr>
                                    <tr>
                                      <td>XLX</td>
                                      <td>n/a</td>
                                    </tr>
                                    <tr>
                                      <td>XXL</td>
                                      <td>41 - 43</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Footwear</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>U.S. Size</th>
                                      <th>Euro Size</th>
                                      <th>Inches</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>6</td>
                                      <td>38</td>
                                      <td>9.25</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>39</td>
                                      <td>9.63</td>
                                    </tr>
                                    <tr>
                                      <td>7.5</td>
                                      <td>40 - 41</td>
                                      <td>9.75</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>41</td>
                                      <td>9.94</td>
                                    </tr>
                                    <tr>
                                      <td>8.5</td>
                                      <td>41 - 42</td>
                                      <td>10.13</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>42</td>
                                      <td>10.25</td>
                                    </tr>
                                    <tr>
                                      <td>9.5</td>
                                      <td>42 - 43</td>
                                      <td>10.44</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td>43</td>
                                      <td>10.56</td>
                                    </tr>
                                    <tr>
                                      <td>10.5</td>
                                      <td>43 - 44</td>
                                      <td>10.75</td>
                                    </tr>
                                    <tr>
                                      <td>11</td>
                                      <td>44</td>
                                      <td>10.94</td>
                                    </tr>
                                    <tr>
                                      <td>11.5</td>
                                      <td>44 - 45</td>
                                      <td>11.13</td>
                                    </tr>
                                    <tr>
                                      <td>12</td>
                                      <td>45</td>
                                      <td>11.25</td>
                                    </tr>
                                    <tr>
                                      <td>13</td>
                                      <td>46</td>
                                      <td>11.56</td>
                                    </tr>
                                    <tr>
                                      <td>14</td>
                                      <td>47</td>
                                      <td>11.88</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Men's Hats</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <td>Alpha</td>
                                      <td>Fitted</td>
                                      <td>Inches</td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>S/M</td>
                                      <td>6 7/8 - 7 1/8</td>
                                      <td>21.6 - 22.38</td>
                                    </tr>
                                    <tr>
                                      <td>OSFM*</td>
                                      <td>7 1/8 - 7 3/8</td>
                                      <td>22.38 - 23.13</td>
                                    </tr>
                                    <tr>
                                      <td>L/XL</td>
                                      <td>7 3/8 - 7 5/8</td>
                                      <td>23.13 - 23.88</td>
                                    </tr>
                                    <tr>
                                      <td>XXL</td>
                                      <td>7 3/4 - 7 7/8</td>
                                      <td>24.25 - 24.63</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <p className="chart-note">
                                          * One Size Fits Most
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Men's Belts</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Inches</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>S</td>
                                      <td>30 - 32</td>
                                    </tr>
                                    <tr>
                                      <td>M</td>
                                      <td>34 - 36</td>
                                    </tr>
                                    <tr>
                                      <td>L</td>
                                      <td>38 - 40</td>
                                    </tr>
                                    <tr>
                                      <td>XL</td>
                                      <td>42 - 44</td>
                                    </tr>
                                    <tr>
                                      <td>1X</td>
                                      <td>46 - 48</td>
                                    </tr>
                                    <tr>
                                      <td>2X</td>
                                      <td>50 - 52</td>
                                    </tr>
                                    <tr>
                                      <td>3X</td>
                                      <td>54 - 56</td>
                                    </tr>
                                    <tr>
                                      <td>4X</td>
                                      <td>56 - 58</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          <div
                            className={`pw-tabs__panel ${selectedIndex === 1 ? "pw--is-active" : ""
                              }`}
                            aria-hidden={selectedIndex === 1}
                            tabIndex="-1"
                            role="tabpanel"
                          >
                            <div className="u-padding-md">
                              <div
                                className="size-chart-modal-units"
                                onClick={() => setMetric(true)}
                                tabIndex="0"
                              >
                                <p className="u-text-align-center">
                                  Shown in inches.{" "}
                                  <span>Convert to centimeters.</span>
                                </p>
                              </div>

                              <div>
                                <h4>Apparel | XXS - XL, 0-16</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Bust</th>
                                      <th>Waist</th>
                                      <th>Hips</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XXS / 0</td>
                                      <td>32.5</td>
                                      <td>25</td>
                                      <td>35.5</td>
                                    </tr>
                                    <tr>
                                      <td>XS / 2</td>
                                      <td>33.5</td>
                                      <td>26.5</td>
                                      <td>37</td>
                                    </tr>
                                    <tr>
                                      <td>S / 4-6</td>
                                      <td>34.5 - 35.5</td>
                                      <td>27.5 - 28.5</td>
                                      <td>38 - 39</td>
                                    </tr>
                                    <tr>
                                      <td>M / 8-10</td>
                                      <td>36.5 - 37.5</td>
                                      <td>29.5 - 30.5</td>
                                      <td>40 - 41</td>
                                    </tr>
                                    <tr>
                                      <td>L / 12-14</td>
                                      <td>39 - 40.5</td>
                                      <td>32 - 33.5</td>
                                      <td>42.5 - 44</td>
                                    </tr>
                                    <tr>
                                      <td>XL / 16</td>
                                      <td>42</td>
                                      <td>35</td>
                                      <td>45.5</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Denim | 24-33</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Natural Waist</th>
                                      <th>Low Hip</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>24</td>
                                      <td>24</td>
                                      <td>33.5</td>
                                    </tr>
                                    <tr>
                                      <td>25</td>
                                      <td>25</td>
                                      <td>35</td>
                                    </tr>
                                    <tr>
                                      <td>26</td>
                                      <td>26</td>
                                      <td>36.5</td>
                                    </tr>
                                    <tr>
                                      <td>27</td>
                                      <td>27</td>
                                      <td>37.5</td>
                                    </tr>
                                    <tr>
                                      <td>28</td>
                                      <td>28</td>
                                      <td>38.5</td>
                                    </tr>
                                    <tr>
                                      <td>29</td>
                                      <td>29</td>
                                      <td>39.5</td>
                                    </tr>
                                    <tr>
                                      <td>30</td>
                                      <td>30</td>
                                      <td>40.5</td>
                                    </tr>
                                    <tr>
                                      <td>31</td>
                                      <td>31.5</td>
                                      <td>42</td>
                                    </tr>
                                    <tr>
                                      <td>32</td>
                                      <td>33</td>
                                      <td>43.5</td>
                                    </tr>
                                    <tr>
                                      <td>33</td>
                                      <td>34.5</td>
                                      <td>45</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Swim Separates</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Bust</th>
                                      <th>Waist</th>
                                      <th>Hips</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XS / 4</td>
                                      <td>33.5</td>
                                      <td>27</td>
                                      <td>37</td>
                                    </tr>
                                    <tr>
                                      <td>S / 6-8</td>
                                      <td>34.5</td>
                                      <td>28</td>
                                      <td>38</td>
                                    </tr>
                                    <tr>
                                      <td>M / 10-12</td>
                                      <td>36</td>
                                      <td>29.5</td>
                                      <td>39.5</td>
                                    </tr>
                                    <tr>
                                      <td>L / 14</td>
                                      <td>37.5</td>
                                      <td>31</td>
                                      <td>41</td>
                                    </tr>
                                    <tr>
                                      <td>XL / 16</td>
                                      <td>39</td>
                                      <td>32.5</td>
                                      <td>42.5</td>
                                    </tr>
                                    <tr>
                                      <td>1X / 16W</td>
                                      <td>43</td>
                                      <td>36</td>
                                      <td>46</td>
                                    </tr>
                                    <tr>
                                      <td>2X / 18W-20W</td>
                                      <td>44.5</td>
                                      <td>37.5</td>
                                      <td>47.5</td>
                                    </tr>
                                    <tr>
                                      <td>3X / 22W</td>
                                      <td>46</td>
                                      <td>39</td>
                                      <td>49</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>One-Piece Suits</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Bust</th>
                                      <th>Waist</th>
                                      <th>Hips</th>
                                      <th>Torso Length</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>4</td>
                                      <td>32.5</td>
                                      <td>26</td>
                                      <td>36</td>
                                      <td>59.5</td>
                                    </tr>
                                    <tr>
                                      <td>6</td>
                                      <td>33.5</td>
                                      <td>27</td>
                                      <td>37</td>
                                      <td>60.75</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>34.5</td>
                                      <td>28</td>
                                      <td>38</td>
                                      <td>62</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td>35.5</td>
                                      <td>29</td>
                                      <td>39</td>
                                      <td>63.25</td>
                                    </tr>
                                    <tr>
                                      <td>12</td>
                                      <td>36.5</td>
                                      <td>30</td>
                                      <td>40</td>
                                      <td>64.5</td>
                                    </tr>
                                    <tr>
                                      <td>14</td>
                                      <td>37.5</td>
                                      <td>31</td>
                                      <td>41</td>
                                      <td>65.75</td>
                                    </tr>
                                    <tr>
                                      <td>16</td>
                                      <td>38.5</td>
                                      <td>32</td>
                                      <td>42</td>
                                      <td>67</td>
                                    </tr>
                                    <tr>
                                      <td>16W</td>
                                      <td>43</td>
                                      <td>36</td>
                                      <td>46</td>
                                      <td>69</td>
                                    </tr>
                                    <tr>
                                      <td>18W</td>
                                      <td>44</td>
                                      <td>37</td>
                                      <td>47</td>
                                      <td>70.25</td>
                                    </tr>
                                    <tr>
                                      <td>20W</td>
                                      <td>45</td>
                                      <td>38</td>
                                      <td>48</td>
                                      <td>71.5</td>
                                    </tr>
                                    <tr>
                                      <td>22W</td>
                                      <td>46</td>
                                      <td>39</td>
                                      <td>49</td>
                                      <td>72.75</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Swim Coverups</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Size</th>
                                      <th>Bust</th>
                                      <th>Waist</th>
                                      <th>Hips</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XS / 4</td>
                                      <td>33.5</td>
                                      <td>27</td>
                                      <td>37</td>
                                    </tr>
                                    <tr>
                                      <td>S / 6-8</td>
                                      <td>34.5</td>
                                      <td>28</td>
                                      <td>38</td>
                                    </tr>
                                    <tr>
                                      <td>M / 10-12</td>
                                      <td>36.5</td>
                                      <td>30</td>
                                      <td>40</td>
                                    </tr>
                                    <tr>
                                      <td>L / 14</td>
                                      <td>38.5</td>
                                      <td>32</td>
                                      <td>42</td>
                                    </tr>
                                    <tr>
                                      <td>XL / 16</td>
                                      <td>40.5</td>
                                      <td>34</td>
                                      <td>44</td>
                                    </tr>
                                    <tr>
                                      <td>1X / 16W</td>
                                      <td>43</td>
                                      <td>36</td>
                                      <td>46</td>
                                    </tr>
                                    <tr>
                                      <td>2X / 18W-20W</td>
                                      <td>45</td>
                                      <td>38</td>
                                      <td>48</td>
                                    </tr>
                                    <tr>
                                      <td>3X / 22W</td>
                                      <td>47</td>
                                      <td>40</td>
                                      <td>50</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Footwear</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>U.S. Size</th>
                                      <th>Euro Size</th>
                                      <th>Inches</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>6</td>
                                      <td>36 - 37</td>
                                      <td>8.88</td>
                                    </tr>
                                    <tr>
                                      <td>6.5</td>
                                      <td>37</td>
                                      <td>9.06</td>
                                    </tr>
                                    <tr>
                                      <td>7</td>
                                      <td>37 - 38</td>
                                      <td>9.25</td>
                                    </tr>
                                    <tr>
                                      <td>7.5</td>
                                      <td>38</td>
                                      <td>9.38</td>
                                    </tr>
                                    <tr>
                                      <td>8</td>
                                      <td>38 - 39</td>
                                      <td>9.5</td>
                                    </tr>
                                    <tr>
                                      <td>8.5</td>
                                      <td>39</td>
                                      <td>9.63</td>
                                    </tr>
                                    <tr>
                                      <td>9</td>
                                      <td>39 - 40</td>
                                      <td>9.88</td>
                                    </tr>
                                    <tr>
                                      <td>9.5</td>
                                      <td>40</td>
                                      <td>10</td>
                                    </tr>
                                    <tr>
                                      <td>10</td>
                                      <td>40 - 41</td>
                                      <td>10.19</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Women's Hats</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Alpha</th>
                                      <th>Hat Size</th>
                                      <th>Inches</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>OSFM*</td>
                                      <td>6 7/8 - 7 1/8</td>
                                      <td>21.63 - 22.63</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <p className="chart-note">
                                          * One Size Fits Most
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Women's Belts</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Pant Size</th>
                                      <th>Belt Size (Buckle)</th>
                                      <th>Belt Size (Braid)</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>2</td>
                                      <td>30 - 32</td>
                                      <td>31 - 33</td>
                                    </tr>
                                    <tr>
                                      <td>4/6</td>
                                      <td>32 - 34</td>
                                      <td>33 - 35</td>
                                    </tr>
                                    <tr>
                                      <td>8/10</td>
                                      <td>34 - 36</td>
                                      <td>35 - 37</td>
                                    </tr>
                                    <tr>
                                      <td>12/14</td>
                                      <td>37 - 39</td>
                                      <td>38 - 40</td>
                                    </tr>
                                  </tbody>
                                </table>
                                <h4>Women's Belts: Alpha Sizing</h4>
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Alpha</th>
                                      <th>Pant Size</th>
                                      <th>Inches</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>XS/S</td>
                                      <td>2 - 6</td>
                                      <td>30 - 34</td>
                                    </tr>
                                    <tr>
                                      <td>M/L</td>
                                      <td>8 - 14</td>
                                      <td>35 - 39</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </main>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Portal>
    </div>
  );
};

export default SizeChart;
